export default __webpack_public_path__ + "static/media/icons8-twitter.53c7e9cf.svg";